export function getOperationName ({ name: { value, }, } = {}) {
  return value
}
